import React from "react";

export const CustomerSettingsContext = React.createContext(null);
